import React from "react";

import { Grid, Tooltip, Avatar } from "@material-ui/core";

export const AvatarParticipante = ({
  onClick,
  infoColaborador,
  noFlex,
  ...props
}) => {
  const defaultFunction = () => {};
  const styleInfoTooltip = {
    overflow: "hidden",
    color: "var(--ds-text-inverse, #ffffff)",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily:
      "BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif",
  };

  const CardColaborador = (data) => {
    return (
      <Grid
        container
        spacing={0}
        style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }}
      >
        <Grid
          item
          xs={12}
          style={{ backgroundColor: "#0c66e4", borderRadius: "10px 10px 0 0" }}
        >
          <Grid container spacing={0}>
            <Grid item xs={4}></Grid>
            <Grid item xs={8}>
              <Grid container spacing={0} style={styleInfoTooltip}>
                <Grid item xs={12} style={{ marginBottom: "10px" }}>
                  {data?.nombre || "d"}
                </Grid>
                <Grid item xs={12}>
                  {data?.correo || "d"}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ height: "30px" }}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={4}
              style={{ marginTop: "-22px", marginLeft: "10px" }}
            >
              <Avatar
                style={{
                  backgroundColor: data?.color || "blue",
                  color: "#FFFF",
                }}
              >
                {data?.avatar || "00"}
              </Avatar>
            </Grid>
            <Grid item xs={8} />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid
      container
      spacing={0}
      style={
        noFlex
          ? {}
          : {
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              alignItems: "flex-end",
            }
      }
    >
      <Tooltip
        title={CardColaborador(infoColaborador)}
        arrow
        sx={{
          "& .MuiTooltip-arrow": {
            backgroundColor: "red",
          },
        }}
      >
        <Avatar
          style={{
            width: "30px",
            height: "30px",
            fontSize: "small",
            backgroundColor: infoColaborador?.color || "blue",
            color: "#FFFF",
            marginRight: "-5px",
          }}
          onClick={onClick || defaultFunction}
        >
          {infoColaborador?.avatar || "00"}
        </Avatar>
      </Tooltip>
    </Grid>
  );
};
